import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './Navbar.css';
import Login from '../Login/Login.js';
import Register from '../Register/Register.js';
import '../../globalcss.css';
import { Menu, Icon, Button, Dropdown, Input, Modal, Tabs, Row, Col, Form } from 'antd';
import 'react-sticky-header/styles.css';
import { NavLink, withRouter } from 'react-router-dom';
import * as actioncreators from '../../redux/action';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import Tapalert from '../../Images/notification.png';
import { config } from '../../config';

const TabPane = Tabs.TabPane;

function callback(key) {
    console.log(key);
}

class Navbar extends Component {

    state = {}

    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            user: ''
        }
    }

    componentDidMount() {

        if (this.props.loggeduserDetails.type == 'Individual') {
            this.setState({ user: this.props.loggeduserDetails.type })
        }
    }

    // modal function start
    showModal = () => {
        this.setState({
            visible: true,
        });
    }

    handleOk = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }

    // closing modal function
    handleCancel = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }

    // menu handle function
    handleMenu = ({ key }) => {
        switch (key) {
            case "logout":
                this.handleLogout();
                break;
        }
    }

    componentWillReceiveProps(newprops) {
        this.commonFunction(newprops);
        console.log(newprops);
    }

    // menu for login user
    menu = (
        <Menu onClick={this.handleMenu}>
            <Menu.Item key="settings">
                <NavLink to="/mytaps"><Icon type="calendar" theme="outlined" /> &nbsp; My Taps</NavLink>
            </Menu.Item>
            <Menu.Item key="settings">
                <NavLink to="/payment"><Icon type="setting" theme="outlined" /> &nbsp; Payment</NavLink>
            </Menu.Item>
            <Menu.Item key="settings">
                <NavLink to="/profile"><Icon type="setting" theme="outlined" /> &nbsp; Settings</NavLink>
            </Menu.Item>
            <Menu.Item key="ical">
                <NavLink to="/profile/ical"><Icon type="calendar" theme="outlined" /> &nbsp; Calendar</NavLink>
            </Menu.Item>
            <Menu.Item key="profile">
                <NavLink to="/profile" ><Icon type="profile" theme="outlined" /> &nbsp; Profile</NavLink>
            </Menu.Item>
            <Menu.Item key="notification">
                <NavLink to="/profile/eventlist"><Icon type="schedule" theme="outlined" /> &nbsp; Event</NavLink>
            </Menu.Item>
            {
                (this.state.user != 'Individual') ?

                    <Menu.Item key="share">
                        <NavLink to="/profile/grouplist"><Icon type="team" theme="outlined" /> &nbsp; Business</NavLink>
                    </Menu.Item>
                    : ''}
            {
                (this.state.user != 'Individual') ?
                    <Menu.Item key="share">
                        <NavLink to="/profile/businessapi"><Icon type="key" theme="outlined" /> &nbsp; API Keys</NavLink>
                    </Menu.Item>
                    : ''}
            <Menu.Item key="logout">
                <Icon type="export" theme="outlined" /> Logout
            </Menu.Item>
        </Menu>
    );

    // user logout function
    handleLogout = (e) => {
        localStorage.removeItem('id');
        localStorage.removeItem('session');
        this.props.actions.userdetails(localStorage.getItem('session'));
        this.props.history.push('/home');
    }

    commonFunction(newProps) {

        if (newProps.loggeduserDetails && newProps.loggeduserDetails.name) {
            this.setState({ userStyle: { display: 'block' } })
            this.setState({ loginStyle: { display: 'none' } })
            this.setState({ username: newProps.loggeduserDetails.name })
        }
        else {
            this.setState({ loginStyle: { display: 'block' } })
            this.setState({ userStyle: { display: 'none' } })
        }
    }

    componentWillMount() {
        this.props.actions.userdetails(localStorage.getItem('session'))
        console.log(this.props.loggeduserDetails.type);
        this.commonFunction(this.props);
    }

    // responsive menu fold
    toggleCollapsed = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }
    render() {

        return (
            <div className="navbarcomp">
                <div className="stickynavbar">
                    <div className="container">
                        <Row type="flex">
                            <Col lg={{ span: 14 }} xs={{ span: 24 }}>
                                <p className="m0 text-left notify"><span><Icon type="phone" className="white" />
                                    123-456-7890</span>
                                    <span><Icon type="mail" className="white" /> abc@gmail.com</span>
                                    <span> <Icon type="environment-o" className="white" /> 23Avenue Park Road</span>
                                </p>
                            </Col>
                            <Col lg={{ span: 10 }} xs={{ span: 24 }}>
                                {/* user before login start */}

                                {((this.props.loggeduserDetails && !this.props.loggeduserDetails.name)
                                    || !this.props.loggeduserDetails) &&
                                    <div className="uppertext">
                                        <div className="loginbtn">
                                            <p className="m0"><Icon type="unlock" className="white" />
                                                <Button activeClassName="active" onClick={this.showModal}>Login </Button>/
                                                <Button onClick={this.showModal} activeClassName="active"> Sign up </Button>
                                            </p>
                                        </div>
                                    </div>
                                }
                                {/* user before login end */}

                                {/* user after login start */}
                                {this.props.loggeduserDetails && this.props.loggeduserDetails.name &&
                                    <div className="uppertext">
                                        <p className="white" > <NavLink to="/profile/notification"><span>5</span><img src={Tapalert} alt="TapMeNow" /> </NavLink></p>
                                        <div className="loginbtn">
                                            <Dropdown overlay={this.menu} trigger={['click']}>
                                                <ul className="list-inline m0">
                                                    <li className="proimgshow">
                                                        {this.props.loggeduserDetails.imageUrl ? <a href="#"><img src={this.props.loggeduserDetails.imageUrl} alt="tapmenow" /></a> : (this.props.loggeduserDetails.imageId ? <a href="#"><img src={config.API_URL + 'file?file=' + this.props.loggeduserDetails.imageId} alt="tapmenow" /></a> : null)}
                                                    </li>
                                                    <li className="white">
                                                        {this.props.loggeduserDetails.name}<Icon type="down" />
                                                    </li>
                                                </ul>
                                            </Dropdown>
                                        </div>
                                    </div>
                                }
                                {/* user after login end */}

                            </Col>
                        </Row>

                        {/* sign in sign up modal start */}
                        <Modal
                            title="Basic Modal"
                            className="loginmodal"
                            visible={this.state.visible}
                            onOk={this.handleOk}
                            onCancel={this.handleCancel}
                        >
                            <Tabs onChange={callback} type="card">
                                <TabPane tab="Sign In" key="1">
                                    <Login handleCancel={this.handleCancel} />
                                </TabPane>
                                <TabPane tab="Sign Up" key="2">
                                    <Register handleCancel={this.handleCancel} />
                                </TabPane>
                            </Tabs>
                        </Modal>
                        {/* sign in sign up modal end */}

                    </div>
                </div>
                <div className="navbarSec hidden-xs">
                    <div className="container">
                        <div className="logosec"><NavLink to="/home"> <p className="m0">TapMeNow</p></NavLink>

                        </div>
                        <Menu mode="horizontal" className="navitem">
                            <Menu.Item key="home">
                                Home
                                <NavLink to="/home" activeClassName="active"></NavLink>
                            </Menu.Item>
                            <Menu.Item key="about">
                                About
                                <NavLink to="/about"></NavLink>
                            </Menu.Item>
                            <Menu.Item key="browse">
                                Browse
                                <NavLink to="/browse"></NavLink>
                            </Menu.Item>
                            <Menu.Item key="support">
                                Support
                            </Menu.Item>
                            <Menu.Item key="contact">
                                Contact
                                <NavLink to="/contact"></NavLink>
                            </Menu.Item>
                            <Menu.Item key="library" className="searchmenu">
                                <div className="search-box">
                                    <Input className="s-box" type="text" name="search" placeholder="Search Event" />
                                    <a class="s-btn">
                                        <Icon type="search" className="white m0" />
                                    </a>
                                </div>
                            </Menu.Item>
                        </Menu>
                    </div>
                </div>

                {/* navbar for mobile section start */}
                <div className="collapsed-navbar text-left hidden-lg">
                    <Button className="collapsedbtn" type="primary" onClick={this.toggleCollapsed}>
                        <Icon type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'} />
                    </Button>
                    <Menu
                        defaultSelectedKeys={['1']}
                        defaultOpenKeys={['sub1']}
                        mode="inline"
                        theme="dark"
                        inlineCollapsed={this.state.collapsed}
                    >
                        <Menu.Item key="home">
                            Home
                            <NavLink to="/home" activeClassName="active"></NavLink>
                        </Menu.Item>
                        <Menu.Item key="about">
                            About
                            <NavLink to="/about"></NavLink>
                        </Menu.Item>
                        <Menu.Item key="browse">
                            Browse
                            <NavLink to="/browse"></NavLink>
                        </Menu.Item>
                        <Menu.Item key="create">
                            Contact
                            <NavLink to="/contact"></NavLink>
                        </Menu.Item>
                        <Menu.Item key="support">
                            Support
                        </Menu.Item>
                        <Menu.Item key="library" className="searchmenu">
                            <div className="search-box">
                                <Input className="s-box" type="text" name="search" placeholder="Search Event" />
                                <a class="s-btn">
                                    <Icon type="search" className="white m0" />
                                </a>
                            </div>
                        </Menu.Item>
                    </Menu>
                </div>
                {/* navbar for mobile section start */}

            </div>

        );
    }
}
const mapStateToProps = (state) => {
    return state
}
function mapDispatchToProps(dispatch, state) {
    return ({
        actions: bindActionCreators(actioncreators, dispatch)
    })
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));


// WEBPACK FOOTER //
// ./src/Component/Navbar/Navbar.js